import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import Slide from '@mui/material/Slide';
import { FaExpand } from 'react-icons/fa';
import ReportDashboard from '../PageLayout/Dashboard/ReportDashboard';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ReportPopUp({reportid,pagename}) {
  const [open, setOpen] = React.useState(false);
  console.log(reportid)

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <span onClick={handleClickOpen}>
         <FaExpand style={{fontSize:"20px"}} />
      </span>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        id='PowerbiReportView'
      >
        <DialogContent>
                <ReportDashboard reportid = {reportid === "1" ? 101 : parseInt(reportid) } reportnameFetch={pagename}/>
        </DialogContent>
        <DialogActions>
         
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}